<form [formGroup]="contractManagerFormGroup" class="category-content">

    <!-- Agency -->
    <div class="data-container">
        <span class="data-title"> Agence *</span>
        <div class="tv-rect-input-small-no-label full-width">
            <mat-form-field>
                <input
                        matInput
                        formControlName="centralAgency"
                        [matAutocomplete]="autoCentralAgency"
                />
                <mat-error class="error" *ngIf="contractManagerFormGroup.get('centralAgency')?.hasError('required')">
                    Veuillez choisir une centrale
                </mat-error>
                <mat-autocomplete autoActiveFirstOption class="tv-custom-always-visible-scroll-bar"
                                  #autoCentralAgency="matAutocomplete"
                                  [displayWith]="displayAutoCompleteData">
                    <mat-option
                            *ngFor="let centralAgency of filteredCentralAgencyList | async"
                            class="tv-ns-select-option"
                            [value]="centralAgency">
                        {{ centralAgency.name }} - {{ centralAgency.id }}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </div>
    </div>

    <!-- Contract Manager -->
    <div class="data-container">
        <span class="data-title"> Commercial * </span>
        <div class="tv-rect-input-small-no-label full-width">
            <mat-form-field>
                <input
                        matInput
                        formControlName="contractManager"
                        [matAutocomplete]="autoContractManager"
                />
                <mat-error class="error" *ngIf="contractManagerFormGroup.get('contractManager')?.hasError('required')">
                    Veuillez choisir un commercial
                </mat-error>
                <mat-autocomplete autoActiveFirstOption class="tv-custom-always-visible-scroll-bar"
                                  #autoContractManager="matAutocomplete"
                                  [displayWith]="displayAutoCompleteData">
                    <mat-option
                            *ngFor="let contractManager of filteredContractManagerList | async"
                            class="tv-ns-select-option"
                            [value]="contractManager">
                        {{ contractManager.name }} - {{ contractManager.id }}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </div>
    </div>

    <!-- Customer Service Manager -->
    <div class="data-container">
        <span class="data-title"> Chargé de clientèle *</span>
        <div class="tv-rect-input-small-no-label full-width">
            <mat-form-field>
                <input
                        matInput
                        formControlName="customerServiceManager"
                        [matAutocomplete]="autoCustomerServiceManager"
                />
                <mat-error class="error"
                           *ngIf="contractManagerFormGroup.get('customerServiceManager')?.hasError('required')">
                    Veuillez choisir un chargé de clientèle
                </mat-error>
                <mat-autocomplete autoActiveFirstOption class="tv-custom-always-visible-scroll-bar"
                                  #autoCustomerServiceManager="matAutocomplete"
                                  [displayWith]="displayAutoCompleteData">
                    <mat-option
                            *ngFor="let customerServiceManager of filteredCustomerServiceManagerList | async"
                            class="tv-ns-select-option"
                            [value]="customerServiceManager">
                        {{ customerServiceManager.name }} - {{ customerServiceManager.id }}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </div>
    </div>
</form>
